import { useCallback } from 'react';
import axios from 'axios';

export const useQuickCutActions = ({
  BACKEND_URL,
  showNotification,
  loadClientAcceptedQuickCuts,
  registerCancelledBooking,
  setMatchedBarber,
  setQuickCutStatus,
  setCurrentQuickCutRequestId,
  currentQuickCutRequestRef
}) => {
  const handleMarkArrived = useCallback(async (quickCut) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BACKEND_URL}/api/quick-cuts/${quickCut.id}/arrived`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (quickCut?.barber?.id) {
        try {
          await axios.post(`${BACKEND_URL}/api/chat/send`, {
            service_id: quickCut.id,
            recipient_id: quickCut.barber.id,
            message: 'El cliente ha llegado!',
            type: 'system'
          }, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        } catch (chatError) {
          console.error('Error sending arrival message:', chatError);
        }
      }

      showNotification('✅ Llegada marcada', 'Has marcado tu llegada correctamente', 'success');
      loadClientAcceptedQuickCuts?.();
      setTimeout(() => {
        loadClientAcceptedQuickCuts?.();
      }, 1000);
    } catch (error) {
      console.error('Error marking arrival:', error);
      showNotification('❌ Error', 'No se pudo marcar la llegada', 'destructive');
    }
  }, [BACKEND_URL, loadClientAcceptedQuickCuts, showNotification]);

  const handleCancelQuickCutRequest = useCallback(async (quickCut) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BACKEND_URL}/api/quick-cuts/${quickCut.id}/cancel`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showNotification('Solicitud cancelada', 'Tu solicitud fue cancelada', 'info');
      const barbershopId =
        quickCut.barbershop?.id ||
        quickCut.barbershop_id ||
        quickCut.barber?.barbershop_id;
      registerCancelledBooking?.(quickCut.id, barbershopId);
      loadClientAcceptedQuickCuts?.();
      setMatchedBarber(null);
      setQuickCutStatus('idle');
      setCurrentQuickCutRequestId(null);
      if (currentQuickCutRequestRef) {
        currentQuickCutRequestRef.current = null;
      }
    } catch (error) {
      console.error('Error canceling quick cut:', error);
      showNotification('❌ Error', 'No se pudo cancelar la solicitud', 'destructive');
    }
  }, [
    BACKEND_URL,
    currentQuickCutRequestRef,
    loadClientAcceptedQuickCuts,
    registerCancelledBooking,
    setCurrentQuickCutRequestId,
    setMatchedBarber,
    setQuickCutStatus,
    showNotification
  ]);

  return { handleMarkArrived, handleCancelQuickCutRequest };
};
